import { render, staticRenderFns } from "./UserChipMovementsCard.vue?vue&type=template&id=8acdf00c&"
import script from "./UserChipMovementsCard.vue?vue&type=script&lang=js&"
export * from "./UserChipMovementsCard.vue?vue&type=script&lang=js&"
import style0 from "./UserChipMovementsCard.vue?vue&type=style&index=0&id=8acdf00c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports